import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../contexts/AppContext";
import { YourApplicationModel } from "../../../apis/ApisYourApplications";
import Select, { StylesConfig } from 'react-select';
import { FilterOption } from "../Shared/SharedTypes";
import { ErrorsDisplay } from "../Shared/Error";
import { API_AddSupplementaryInformation } from "../../../apis/ApisSupplementaryInformation";
import toast from "react-hot-toast";

export type AdditionalInformationProps = {
    applications: YourApplicationModel[],
    reload: () => void,
}

export function AdditionalInformationForm(props: AdditionalInformationProps) {
    let isLoading = props.applications == null;
    const [errors, setErrors] = useState<string[]>([]);

    const app = useContext(AppContext);
    const [inputText, setInputText] = useState<string>('');
    const [filters, setFilters] = useState<FilterOption[]>([]);
    const [selectedOption, setSelectedOption] = useState<FilterOption[]>(null);
    const [saving, setSaving] = useState<boolean>(false);

    useEffect(() => {
        if (props.applications != null) {
            setFilters([...props.applications.filter(x => x.Completed).map(x => { return ({ value: x.ApplicationNumber.toString(), label: x.ApplicationNumber.toString() }) })]);
        }
    }, [props.applications]);

    const style: StylesConfig<any> = {
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
                ...styles,
                backgroundColor: isSelected
                    ? app.styleColourAlternative
                    : isFocused
                        ? app.styleColourSecondary
                        : `#fff`,
                color: isSelected
                    ? `#fff`
                    : isFocused
                        ? `#fff`
                        : `#000`,
            };
        },
    };

    const submit = async () => {
        let errors: string[] = [];

        if (inputText.length == 0) {
            errors = ([...errors, "Please provide supplementary information"]);
        }
        if (selectedOption == null || selectedOption.length == 0) {
            errors = ([...errors, "Please select an application"]);
        }

        if (errors.length == 0) {
            setSaving(true);
            await API_AddSupplementaryInformation({Applications: selectedOption.map(x => x.value), Body: inputText, DateAdded: null, Type: "Other", SupplementaryInfoId: -1, ApplicantRef: null });
            toast.success("Added");
            clear();
            props.reload();
        }

        setErrors(errors);
    }

    const clear = async () => {
        setInputText('');
        setSelectedOption(null);
        setErrors([]);
        setSaving(false);
    }

    return (
        <>
            <p dangerouslySetInnerHTML={{ __html: app.baseFeatures.SupplementaryInformationText }}></p>
            {filters != null && (props.applications == null ? 0 : props.applications.filter(x => x.Completed).length) > 0 &&
                <form className="d-flex flex-column gap-2 mt-3">
                    <ErrorsDisplay errors={errors} />

                    <div className="col-auto">
                        <label htmlFor="appSelectControl" className="form-label-alt">Selected applications (Ref)</label>
                        <Select
                            isMulti
                            name="select apps"
                            placeholder="Please select"
                            styles={style}
                            defaultValue={selectedOption}
                            isLoading={filters == null}
                            isDisabled={filters == null || filters.length == 0}
                            theme={(theme) => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary25: app.styleColourSecondary,
                                    primary: app.styleColourSecondary,
                                },
                            })}
                            value={selectedOption}
                            onChange={setSelectedOption}
                            options={filters}
                        />
                    </div>
                    <div className="col-auto">
                        <label htmlFor="typeControl" className="form-label-alt">Supplementary information</label>
                        <textarea
                            className="form-control"
                            aria-label="Supplementary information input"
                            rows={4}
                            value={inputText}
                            disabled={isLoading || (selectedOption == null || selectedOption.length == 0)}
                            maxLength={2000}
                            onChange={t => {
                                setInputText(t.currentTarget.value);
                            }}></textarea>
                    </div>
                    <div className="col-auto d-flex gap-2">
                        <button className="btn btn-outline-soft" disabled={isLoading || !((selectedOption != null && selectedOption.length != 0))} onClick={e => {
                            e.preventDefault();
                            clear();
                        }}>Cancel</button>
                        <button className="btn btn-alt" type="submit" disabled={saving || isLoading || (selectedOption == null || selectedOption.length == 0)} onClick={e => {
                            e.preventDefault();
                            submit();
                        }}>Save</button>
                    </div>
                </form>
            }
        </>
    );
}